import React from "react";
import "./ECommerce.css";
import "../Page.css";
import axios from "axios";
import { calculateCartTotal, security_key, Url } from "../../Services/Api";
import CustomBtn from "../../Components/UI-Controls/Buttons/Btn";
import actionIcon from "../../Assets/Images/ActionBtn 30 x 30.png";
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from "react-accessible-accordion";
import "react-accessible-accordion/dist/fancy-example.css";
import DataTable from "react-data-table-component";
import { useState, useEffect } from "react";
// import MainLoader from "../../Components/UI-Controls/MainLoader/MainLoader";
import { format, formatDistanceToNow, isYesterday, parseISO } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { formatDate } from "../../Components/UI-Controls/DateFormat/DateFormat1";
import LastActiveTimestamp from "../../Components/UI-Controls/DateFormat/LastActive";
import ShimmerLoader from "../../Components/UI-Controls/Loader/ShimmerLoader";
import Pagination from "../../Components/UI-Controls/Pagination/PaginationRashid";
import InputField from "../../Components/UI-Controls/InputField/InputField";
import { IoEyeOutline } from "react-icons/io5";
import { RiDeleteBin6Line } from "react-icons/ri";
import { FiEdit } from "react-icons/fi";
import BottomToust from "../../Components/BottomToust/BottomToust";
import LastActivityTimestamp from "../../Components/UI-Controls/DateFormat/LastActivity";
import ElipticalPagenation from "../../Components/UI-Controls/Pagination/Pagination2";
import { useNavigate, useLocation } from "react-router-dom";

const CartIntList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const rowsPerPage = 10;
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [openDropdownId, setOpenDropdownId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [filtersApplied, setFiltersApplied] = useState(false);
    const [custName, setCustName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNo, setPhoneNo] = useState("");
    const [filtersModified, setFiltersModified] = useState(false);
    const [filteredData, setFilteredData] = useState(data);
    const [selectedRows, setSelectedRows] = useState([]);
    const [showMessage, setShowMessage] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [error, setError] = useState(null);

    const [paginationData, setPaginationData] = useState({
        totalItems: 0,
        currentPage: 1,
        totalPages: 1,
        pageSize: 10,
        hasNextPage: false,
        hasPrevPage: false,
    });


    useEffect(() => {
        fetchTableData();
    }, []);

    const timeZone = "America/New_York";

    async function fetchTableData(page = 1, pageSize = 10) {
        setLoading(true);
        setError(null);
        try {
            const URL = `${Url}/api/v1/unused-cart/get-int?page=${page}&limit=${pageSize}`;
            const token = sessionStorage.getItem('authToken');
            const headers = {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
                'x-api-key': security_key
            };

            const response = await axios.get(URL, { headers });
            const responseData = response.data;

            setData(responseData.data); // your current page's data
            setFilteredData(responseData.data); // update filtered as well
            setPaginationData(responseData.pagination); // we'll create this in step 2

            setToastMessage("Cart Abandoned Data fetched successfully!");
            setShowMessage(true);
        } catch (error) {
            const errMsg = error?.response?.data?.message || error.message;
            setError(errMsg);
            setToastMessage(`Failed to fetch data: ${errMsg}`);
            setShowMessage(true);
        } finally {
            setLoading(false);
        }
    }


    const customStyles = {
        headCells: {
            style: {
                height: "clamp(50px, 5vw, 56px)",
                background: "transparent",
                opacity: "1",
                textAlign: "center",
                justifyContent: "center",
                border: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-medium)",
                fontSize: "clamp(var(--font-size-medium), 0.8vw, calc(var(--font-size-medium) + 2px))",
            },
        },
        cells: {
            style: {
                height: "clamp(50px, 6vw, 66px)",
                justifyContent: "center",
                textAlign: "center",
                background: "transparent",
                borderTop: "var(--standered-border)",
                borderRight: "none",
                color: "var(--text-color-1)",
                fontFamily: "var(--font-family)",
                fontWeight: "var(--font-weight-regular)",
                fontSize: "clamp(var(--font-size-small), 0.8vw, calc(var(--font-size-small) + 2px))",
            },
        },
    };

    const toggleDropdown = (id) => {
        setOpenDropdownId((prevId) => (prevId === id ? null : id));
    };


    const handleView = (row) => {
        // Extract the first part of the pathname (e.g. '/Cart/...', '/E-Commerce/...')
        const centralRouteName = location.pathname.split("/")[1];

        if (centralRouteName === "Cart") {
            navigate(`/Cart/cart-initiated/${row._id}`, { state: row });
        } else {
            navigate(`/E-Commerce/cart-initiated/${row._id}`, { state: row });
        }
    };


    const handleAction = (action, row) => {
        console.log(`Action: ${action} triggered for row:`, row);
        switch (action) {
            case "view":
                handleView(row);
                break;
            case "edit":
                setOpenDropdownId(null);
                break;
            case "delete":
                setOpenDropdownId(null);
                break;
            default:
                break;
        }
    };

    const handleClickOutside = (event) => {
        if (
            !event.target.closest(".dropdown-menu") &&
            !event.target.closest(".bar-icon")
        ) {
            setOpenDropdownId(null);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    const handleCloseMessageModal = () => {
        setShowMessage(false);
    };

    useEffect(() => {
        if (showMessage === true) {
            const timeOut = setTimeout(() => {
                setShowMessage(false);
            }, 3000);

            return () => clearTimeout(timeOut);
        }
    }, [showMessage]);

    const CustomerColumns = [
        {
            name: (
                <input
                    type="checkbox"
                    style={{ margin: 0 }}
                    onChange={(e) => handleSelectAll(e.target.checked)}
                    checked={selectedRows.length === data.length && data.length > 0}
                />
            ),
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="20px" height="20px" />
                ) : (
                    <input
                        type="checkbox"
                        style={{ margin: 0 }}
                        onChange={() => handleRowSelect(row._id)}
                        checked={selectedRows.includes(row._id)}
                    />
                ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
            width: "50px",
        },
        {
            name: "Customer Ip",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="200px" height="22.5px" borderRadius="20px" />
                ) : (
                    <div>
                        {row?.cart?.ipAddress}
                    </div>
                ),
            minWidth: "280px",
            maxWidth: "350px",
        },
        {
            name: "Total",
            selector: (row) => {
                if (loading) {
                    return <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />;
                }
                else {
                    return <div>${calculateCartTotal(row?.cart)}</div>
                }
            },
            minWidth: "80px",
            maxWidth: "100px",
        },
        {
            name: "Products",
            selector: (row) =>
                loading ? (
                    <ShimmerLoader width="90px" height="22.5px" borderRadius="20px" />
                ) : row.cart?.products ? (
                    row.cart?.products?.length
                ) : (
                    0
                ),
            minWidth: "80px",
            maxWidth: "100px",
        },
        {
            name: "Last Activity",
            selector: (row) => row?.cart?.updatedAt,
            minWidth: "200px",
            maxWidth: "250px",
            cell: (row) => {
                if (loading) {
                    return <ShimmerLoader width="120px" height="22.5px" borderRadius="20px" />;
                }

                if (row?.cart?.updatedAt) {
                    const lastLoginAt = formatDate(row?.cart?.updatedAt);
                    const now = new Date();
                    let displayText;

                    if (isYesterday(lastLoginAt)) {
                        displayText = `Yesterday, ${format(lastLoginAt, "h:mm a")}`;
                    } else if (now - lastLoginAt < 24 * 60 * 60 * 1000) {
                        displayText = formatDistanceToNow(lastLoginAt, { addSuffix: true });
                    } else {
                        displayText = <LastActivityTimestamp createdAt={row?.cart?.updatedAt} />;
                    }

                    return (
                        <div style={{
                            whiteSpace: "normal",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            display: "-webkit-box",
                            WebkitLineClamp: 2,
                            WebkitBoxOrient: "vertical",
                            maxHeight: "44px",
                        }}>
                            {displayText}
                        </div>
                    );
                }

                return "No data";
            },
        },




        {
            name: "Action",
            cell: (row) =>
                loading ? (
                    <ShimmerLoader width="60px" height="22.5px" />
                ) : (
                    <div style={{ position: "relative" }}>
                        <img
                            src={actionIcon}
                            alt="Action Icon"
                            width="40"
                            height="40"
                            style={{ cursor: "pointer", margin: 0, padding: 0 }}
                            className={`bar-icon ${openDropdownId === row._id ? "rotated" : ""
                                }`}
                            onClick={() => toggleDropdown(row._id)}
                        />
                        {openDropdownId === row._id && (
                            <div className={`dropdown-menu show animate-dropdown-left`}>
                                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                                    <li
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            padding: "5px 10px",
                                            border: "none",
                                        }}
                                        onClick={() => handleAction("view", row)}
                                    >
                                        <IoEyeOutline style={{ marginRight: "12px" }} className="icon-img-updated" />
                                        View
                                    </li>
                                    <li
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            padding: "5px 10px",
                                            border: "none",
                                        }}
                                        onClick={() => handleAction("edit", row)}
                                    >
                                        <FiEdit style={{ marginRight: "12px" }} className="icon-img-updated" />
                                        Edit
                                    </li>
                                    <li
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            cursor: "pointer",
                                            padding: "5px 10px",
                                            border: "none",
                                        }}
                                        onClick={() => handleAction("delete", row)}
                                    >
                                        <RiDeleteBin6Line style={{ marginRight: "12px" }} className="icon-img-updated" />
                                        Delete
                                    </li>
                                </ul>
                            </div>
                        )}
                    </div>
                ),
            minWidth: "100px",
            maxWidth: "125px",
        },
    ];

    const handleFilters = () => {
        if (!custName && !email && !phoneNo) {
            let warningMessage = "Kindly select or enter respective filtration value...";
            setToastMessage(warningMessage);
            setShowMessage(true);
            return;
        }
        console.log("Selected Filters:", {
            custName,
            email,
            phoneNo,
        });

        const filteredData = data.filter((item) => {
            const fullName = `${item.first_name || ""} ${item.last_name || ""}`
                .trim()
                .toLowerCase();

            const custNameMatch = custName
                ? fullName.includes(custName.toLowerCase())
                : true;

            const emailMatch = email ? item.email.toString().includes(email) : true;

            const phoneMatch = phoneNo ? item.email.toString().includes(email) : true;

            return custNameMatch && emailMatch && phoneMatch;
        });

        setFilteredData(filteredData);
        setFiltersApplied(true);
        setFiltersModified(false);
    };

    useEffect(() => {
        if (filtersApplied && filtersModified) {
            handleFilters();
            setFiltersModified(false);
        }
    }, [custName, email, phoneNo, filtersApplied, filtersModified]);

    const handleFilterChange = (value, fieldName) => {
        if (fieldName === "custName") {
            setCustName(value);
        } else if (fieldName === "email") {
            setEmail(value);
        } else if (fieldName === "phoneNo") {
            setPhoneNo(value);
        }
        setFiltersModified(true);
    };

    const handleResetFilters = () => {
        setCustName("");
        setEmail("");
        setPhoneNo("");
        setFiltersApplied(false);
        setFiltersModified(false);
        fetchTableData();
    };

    const handleSelectAll = (isSelected) => {
        if (isSelected) {
            const allRowIds = data.map((row) => row._id);
            setSelectedRows(allRowIds);
        } else {
            setSelectedRows([]);
        }
    };

    const handleRowSelect = (rowId) => {
        setSelectedRows((prevSelected) => {
            if (prevSelected.includes(rowId)) {
                return prevSelected.filter((id) => id !== rowId);
            } else {
                return [...prevSelected, rowId];
            }
        });
    };

    const totalPages = paginationData.totalPages;

    const paginatedData = filteredData;


    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
        fetchTableData(pageNumber, rowsPerPage);
    };

    const handlePrevPage = () => {
        if (paginationData.hasPrevPage) {
            const prevPage = paginationData.currentPage - 1;
            setCurrentPage(prevPage);
            fetchTableData(prevPage, rowsPerPage);
        }
    };

    const handleNextPage = () => {
        if (paginationData.hasNextPage) {
            const nextPage = paginationData.currentPage + 1;
            setCurrentPage(nextPage);
            fetchTableData(nextPage, rowsPerPage);
        }
    };

    const placeholderRows = Array(7).fill({ uid: "", name: "", image: "" });

    const displayedData = loading ? placeholderRows : filteredData;


    return (
        <div className="AllOrderPage">
            <div className="Filters-Section">
                {/* <Accordion allowZeroExpanded className="accordion">
                    <AccordionItem>
                        <AccordionItemHeading>
                            <AccordionItemButton>Filters</AccordionItemButton>
                        </AccordionItemHeading>
                        <AccordionItemPanel>
                            <div className="filter-row-01">
                                <div className="filter-label">Customer Name</div>
                                <div className="filter-label">Email</div>
                                <div className="filter-label">Phone #</div>
                            </div>
                            <div className="filter-row-02">
                                <InputField
                                    value={custName}
                                    name="custName"
                                    onChange={(e) =>
                                        handleFilterChange(e.target.value, "custName")
                                    }
                                    placeholder="Enter Customer Name"
                                />
                                <InputField
                                    value={email}
                                    name="email"
                                    onChange={(e) => handleFilterChange(e.target.value, "email")}
                                    placeholder="Enter Email Address"
                                />
                                <InputField
                                    value={phoneNo}
                                    name="phoneNo"
                                    onChange={(e) =>
                                        handleFilterChange(e.target.value, "phoneNo")
                                    }
                                    placeholder="Enter Phone Number"
                                />
                            </div>

                            <div className="filter-row-04">
                                {!filtersApplied ? (
                                    <CustomBtn
                                        label="Apply Filters"
                                        withIcon={true}
                                        iconType="filter"
                                        className="FilterBtn-OrderPage"
                                        onClick={handleFilters}
                                        type="submit"
                                    />
                                ) : (
                                    <>
                                        <CustomBtn
                                            label="Reset"
                                            withIcon={true}
                                            iconType="reset"
                                            className="ResetBtn-OrderPage"
                                            onClick={handleResetFilters}
                                            type="button"
                                        />
                                        <CustomBtn
                                            label="Apply Filters"
                                            withIcon={true}
                                            iconType="filter"
                                            className="FilterBtn-OrderPage"
                                            type="submit"
                                            style={{ backgroundColor: "green" }}
                                        />
                                    </>
                                )}
                            </div>
                        </AccordionItemPanel>
                    </AccordionItem>
                </Accordion> */}
            </div>

            {/* {loading && (
        <div className="backdrop">
          <MainLoader />
        </div>
      )} */}

            <div className="Orders-Table-Data">
                <div>
                    <DataTable
                        columns={CustomerColumns}
                        data={displayedData}
                        customStyles={customStyles}
                    />
                    <ElipticalPagenation
                        activePageIndex={currentPage}
                        totalPages={totalPages}
                        onPrevPage={handlePrevPage}
                        onNextPage={handleNextPage}
                        onPageChange={handlePageChange}
                    />
                </div>
            </div>

            <BottomToust
                showMessage={showMessage}
                message={toastMessage}
                handleCloseMessageModal={() => handleCloseMessageModal()}
            />

        </div>
    );
};

export default CartIntList;